import {
  themeOverview,
  ThemePerformanceParams,
  V4ThemePerformanceResponse,
} from '@api';
import { useInfiniteQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const QUERY_KEY_GET_V4_THEME_PERFORMANCE = 'QUERY_KEY_GET_V4_THEME_PERFORMANCE';

const DEFAULT_PAGE_SIZE = 10;

type V4ThemePerformanceParams = Omit<ThemePerformanceParams, 'intraday'>;

export const useGetV4ThemePerformance = (
  params?: V4ThemePerformanceParams,
  enabled = true
) =>
  useInfiniteQuery({
    queryKey: [QUERY_KEY_GET_V4_THEME_PERFORMANCE, params],
    queryFn: async ({ signal, pageParam }) => {
      return await wretchRequest<V4ThemePerformanceResponse>(
        themeOverview.getV4ThemePerformance.path({
          ...params,
          page: pageParam,
        }),
        {
          schema: themeOverview.getV4ThemePerformance.schema,
          options: { signal },
        }
      );
    },
    enabled,
    initialPageParam: 1,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const pageSize = params?.page_size ?? DEFAULT_PAGE_SIZE;
      return lastPage.themes.length === pageSize
        ? lastPageParam + 1
        : undefined;
    },
  });
